import { useEffect, useState, useContext } from 'react'
import { LanguageContext } from '../i18n/context'
import { type ProductModel } from 'interfaces'

export interface ISiteLink {
  siteLinks: { name: string; url: string }[]
}

export const useBrandImage = (
  product: ProductModel | undefined
): [string | null, ISiteLink[]] => {
  const [brandImage, setBrandImage] = useState<string | null>(null)
  const [siteLinks, setSiteLinks] = useState<ISiteLink[]>([])
  const { selectedLanguage } = useContext(LanguageContext)

  useEffect((): void => {
    if (!product) {
      return
    }
    const callBrandUrl = async () => {
      try {
        const brandURL = product.brandUrl
        if (!brandURL) {
          return
        }
        const underscore = selectedLanguage.split('_')
        const language = underscore.length === 2 ? underscore[0] || '' : 'en'
        const country = underscore.length === 2 ? underscore[1] || '' : 'US'

        const request = await fetch(brandURL)
        const response = await request.json()

        const displyFlg = response[country]?.displyFlg?.default
        if (displyFlg === 'false') {
          setBrandImage(null)
          return
        }

        const s3Domain = brandURL.slice(0, brandURL.lastIndexOf('/'))
        const imageUrl =
          response[country]?.[language]?.brandLogo?.logo_100 ||
          response.US?.en?.brandLogo?.logo_100
        const brandImageUrl = imageUrl ? `${s3Domain}/${imageUrl}` : null

        const usaSiteLinks = response.US?.[language]?.siteLinks
        const caSiteLinks = response.CA?.[language]?.siteLinks
        const mexSiteLinks = response.MEX?.[language]?.siteLinks

        setSiteLinks([
          {
            siteLinks: usaSiteLinks || [],
          },
          {
            siteLinks: caSiteLinks || usaSiteLinks || [],
          },
          {
            siteLinks: mexSiteLinks || usaSiteLinks || [],
          },
        ])

        setBrandImage(brandImageUrl)
      } catch (_error: unknown) {
        //
      }
    }
    if (product?.brandUrl && !product?.brandUrl?.includes('null')) {
      callBrandUrl()
    }
  }, [product, selectedLanguage])

  return [brandImage, siteLinks]
}
